import ProductInStockAppView from './views/app.js';
import ProductInStockHelpView from './views/help.js';

export default class ProductInStockApp {
	constructor({
		el,
		modal_placeholder_selector,
		customer
	}) {
		this.el = el;
		this.modal_placeholder = modal_placeholder_selector;
		this.view = null;
		this.help_popup = null;
		this.customer = customer;

		if (this.el) {
			this.btn = this.el.querySelector('button');
			this.btn_help = this.el.querySelector('.btn-help');

			this.product = {
				id: this.el.dataset.productId,
				name: this.el.dataset.productName
			}

			this.init_event_handlers();
		}
	}

	initAppView() {
		this.btn.classList.add('progress');
		this.view = new ProductInStockAppView({
			el: this.modal_placeholder,
			modal_selector: '.product-in-stock-app',
			product: this.product,
			customer: this.customer,
			navigation: {
				image: window.ProductInfo.Image,
				caption: window.ProductInfo.Name
			}
		});
		this.view.once_rendered = () => {
			this.view.init_modal();
			this.view.init_popup_events();
			this.view.open();
			this.btn.classList.remove('progress');
		};
	}

	showHelpPopup (event) {
		event.stopPropagation();

		this.btn_help.classList.add('progress');
		this.help_popup = new ProductInStockHelpView({
			el: this.modal_placeholder,
			modal_selector: '.product-in-stock-app-help',
			navigation: {
				image: window.ProductInfo.Image,
				caption: window.ProductInfo.Name
			}
		});

		this.help_popup.once_rendered = () => {
			this.help_popup.init_modal();
			this.help_popup.init_popup_events();
			this.help_popup.open();
			this.btn_help.classList.remove('progress');
		};
	}

	init_event_handlers() {
		this.btn.addEventListener('click', this.initAppView.bind(this));
		this.btn_help.addEventListener('click', this.showHelpPopup.bind(this));
	}
}
